export type OwOrderStatus = "WIN" | "LOSE";

export const OwOrderStatusChoices = [
  { id: "WIN", name: "盈利" },
  { id: "LOSE", name: "亏损" },
];
